import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-286f005e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "technical-proposal" }

import { ref, onMounted, onUnmounted, computed, watch } from 'vue'
import * as echarts from 'echarts'
import { storeToRefs } from 'pinia'
import { useHomeDataStore } from '@/pinia/useHomeDataStore'
import TitleCpn from '../../../Title/TitleCpn.vue'



export default /*#__PURE__*/_defineComponent({
  __name: 'TechnicalProposal',
  setup(__props) {

const homeDataStore = useHomeDataStore()
const { data } = storeToRefs(homeDataStore)
const chartRef = ref()
const myChart = ref()

const colors = computed<string[]>(() => {
    if (!data.value?.right1) {
        return []
    }
    return data.value.right1.map(item => item.color)
})

const datas = computed(() => {
    if (!data.value?.right1) {
        return []
    }
    return data.value.right1
})

const option = computed(() => {
    return {
            series: [
                {
                    name: '技术领域占比',
                    type: 'pie',
                    radius: ['42%', '55%'],
                    color: colors.value,
                    label: {
                        normal: {
                            /* eslint-disable */
                            formatter: (item: any) => `${item.data.name}：\n${item.data.value}（${item.percent}%）`,
                            textStyle: {
                                color: '#ffffff',
                                fontSize: '1.2rem'
                            }
                        },
                    },
                    labelLine: {
                        normal: {
                            lineStyle: {
                                color: '#ffffff'
                            }
                        }
                    },
                    data: datas.value
                }
            ]
        }
})

onMounted(() => {
    window.addEventListener('resize', handleResize)
})

onUnmounted(() => {
    window.removeEventListener('resize', handleResize)
})

const handleResize = () => {
    myChart.value?.resize()
}

const createChart = async () => {
    try {
        myChart.value = echarts.init(chartRef.value);
        myChart.value.setOption(option.value);
    } catch (error) {
        console.error(error)
    }
}

onMounted(() => {
    setTimeout(() => {
        createChart()
    }, 500)
})

watch(
    option,
    () => { myChart.value?.setOption(option.value) },
    {immediate: true}
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(TitleCpn, { title: "技术领域占比" }),
    _createElementVNode("div", {
      class: "chart-container",
      ref_key: "chartRef",
      ref: chartRef
    }, null, 512)
  ]))
}
}

})